import React, { Component } from 'react';
import { PageHeader } from 'components/page-header';
import { Page } from 'components/page-container';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { fetchReprocesseLogs, resetReprocess } from 'actions/exception-management'
import { ILogsBody } from 'reducers/exception-management/models';
import { setSort } from 'actions/filters';
import { ISortModel } from 'reducers/filters/models';
import { setSortForTable } from 'utilities/tables';
import { ExceptionManagement } from 'components/exception-management/ExceptionManagement';
import { INickname } from 'reducers/nickname';
import InPageDialog from '../../../components/page-dialog';
import { RouteComponentProps, withRouter } from 'react-router';
import { colsReprocess } from 'components/exception-management/constants'
import {
    clearFilters,
    resetSort,
    setFilter,
    applyFiltersAction
} from 'actions/filters';
import { fetchBlob } from 'actions/historyLog';
import { ISort } from 'views/job-costing/search/models';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
interface IMapState {
    data: ILogsBody;
    nickname: INickname;
    blob: any,
    error: any,
    featureToggles: IFeatureToggleModel[]
}

interface IMapDispatch {
    fetchReprocesseLogs: (pageNumber: number, pageSize: number) => Promise<void>;
    resetReprocess: () => void;
    setSort: (sort: ISortModel) => void;
    fetchBlob: (id: any, isReprocess: boolean) => void;
    clearFilters: () => void;
    resetSort: () => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    applyFilters: () => void;
}

interface IEventLogsProps extends RouteComponentProps, IMapState, IMapDispatch { }

interface IEventLogsState {
    sorted: any[] | ISort[];
    isFieldDisabled: boolean;
    fetchInProgress: boolean;
    page: number;
    pageSize: number;
    data: any[],
    file: any,
    timeofrequest: number,
    showDialog: boolean,
    message: string,
    isError: boolean,
    filterKey: string,
    filterValue: string,
    shouldSubmitOnLoad: boolean,
    dateFrom: boolean,
    docNumber: boolean,
}

export class _ReprocessLogs extends Component<IEventLogsProps, IEventLogsState> {
    public state = {
        sorted: [],
        isFieldDisabled: false,
        fetchInProgress: false,
        page: 0,
        pageSize: 10,
        timeofrequest: 0,
        file: '',
        showDialog: false,
        shouldSubmitOnLoad: false,
        data: [],
        message: '',
        isError: true,
        filterKey: '',
        filterValue: '',
        dateFrom: false,
        docNumber: false
    };
    public componentDidUpdate(props: any, state: any) {
        if (this.props.data !== props.data && this.props.data) {
            this.setState({ fetchInProgress: false })
        }
        if (this.props.error !== props.error && this.props.error) {
            this.setState({
                fetchInProgress: false,
                showDialog: true,
                isError: true,
                message: this.props.error
            })
        }
    }
    public componentDidMount() {
        this.setState({
            shouldSubmitOnLoad: true
        }, () => {
            this.fetchEventsList({ page: 0, pageSize: this.state.pageSize })
        })
    }
    public componentWillUnmount() {
        this.props.resetReprocess();
        this.props.clearFilters()
        this.props.resetSort()
    }
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isReprocessWebApiEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_REPROCESS_LOGS, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        return (
            <React.Fragment>
                <PageHeader>Reprocess Logs</PageHeader>
                <Page>
                    <div className={'padding-top-xLarge'}>
                        <Filters
                            tableNameKey="fact"
                            fetchFunction={() => {
                                this.fetchEventsList({ page: 0, pageSize: this.state.pageSize })
                            }}
                            resetErrors={() => {
                                this.applyEmptyFilters()
                                this.setState({ dateFrom: false, docNumber: false })
                            }}
                            disableSubmit={this.state.dateFrom || this.state.docNumber}
                            filters={[
                                <FiltersInput
                                    name="documentNumber"
                                    label="Document Number"
                                    key="documentNumber"
                                    readonly={this.state.isFieldDisabled}
                                />,
                                <FiltersSelect
                                    key={isReprocessWebApiEnabled ? 'DocumentType' :'ItemType'}
                                    name={isReprocessWebApiEnabled ? 'DocumentType' :'ItemType'}
                                    label="Document Type"
                                    isRequired={true}
                                    options={[
                                        { optionText: 'Booking', label: 'Booking', value: 'booking' },
                                        { optionText: 'CBL', label: 'CBL', value: 'cbl' },
                                        { optionText: 'Equipment', label: 'Equipment', value: 'Equipment' },
                                        { optionText: 'ETS', label: 'ETS', value: 'ets' },
                                        { optionText: isExtraDocumentFeatureEnabled ? 'Document' : (isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR'), label: isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR', value: 'fcr' },
                                        { optionText: 'Transport order', label: 'Transport order', value: 'TransportOrder'},
                                    ]}
                                />,
                                <FiltersDateInput
                                    name="dateFrom"
                                    label="Date (from)"
                                    key="dateFrom"
                                    relatedField="dateTo"
                                    type="dateFromTo"
                                    setValidity={(val: any) => this.setState({ dateFrom: val })}
                                    isInvalid={this.state.dateFrom}
                                    withTime={false}
                                />,
                                <FiltersDateInput
                                    name="dateTo"
                                    label="Date (to)"
                                    key="dateto"
                                    type="dateFromTo"
                                    minValue="dateFrom"
                                    setValidity={(val: any) => this.setState({ dateFrom: val })}
                                    isInvalid={this.state.dateFrom}
                                    withTime={false}
                                />
                            ]}
                        />
                        <InPageDialog
                            showDialog={this.state.showDialog}
                            type={this.state.isError ? 'error' : 'success'}
                            message={this.state.message}
                            closeMethod={() => this.setState({ showDialog: false, isError: true })} />
                        <ExceptionManagement
                            file={this.props.blob}
                            cols={colsReprocess}
                            calculateAging={false}
                            fetchData={this.fetchEventsList}
                            data={this.props.data.result}
                            sendReprocess={this.fetchEventsList}
                            toggleReprocess={this.fetchEventsList}                            
                            pageCount={Math.ceil(this.props.data.totalCount / this.state.pageSize)}
                            linkAction={(id: any) => this.props.fetchBlob(id, true)}
                        />
                    </div>
                </Page>
            </React.Fragment>
        );
    }
    private applyEmptyFilters = () => {
        this.props.setFilter('ItemType', 'booking');
        this.props.applyFilters();
    }
    private fetchEventsList = (tableData: any) => {
        const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize) || (new Date().getTime() - this.state.timeofrequest) > 500
        if (samePageRequest && this.state.shouldSubmitOnLoad && !this.state.fetchInProgress) {
            this.setState({
                showDialog: false,
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
                timeofrequest: new Date().getTime(),
                fetchInProgress: true
            }, () => {
                if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && (tableData.sorted[0].id === 'messageDetails' || (tableData.sorted[0].id === 'itemType'))) {
                    this.setState({ fetchInProgress: false });
                    return
                }
                if (tableData && tableData.sorted) {
                    this.setState({ sorted: tableData.sorted });
                    setSortForTable(tableData.sorted, this.props.setSort);
                } else if (this.state.sorted && this.state.sorted.length) {
                    setSortForTable(this.state.sorted, this.props.setSort);
                }
                this.props.fetchReprocesseLogs(this.state.page, this.state.pageSize);
            });
        }
    };
}

const mapStateToProps = (state: IStore): IMapState => ({
    data: state.exceptions.reprocessLogs,
    nickname: state.nickname.userNickName,
    blob: state.historyLog.blob,
    error: state.exceptions.errors || state.historyLog.blobError,
    featureToggles: state.featureToggle.featureToggles
});

const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
    fetchReprocesseLogs: (pageNumber: number, pageSize: number) => dispatch(fetchReprocesseLogs(pageNumber, pageSize)),
    resetReprocess: () => dispatch(resetReprocess()),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    fetchBlob: (id: any, isReprocess: boolean) => dispatch(fetchBlob(id, isReprocess)),
    clearFilters: () => dispatch(clearFilters()),
    resetSort: () => dispatch(resetSort()),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction())
});

export const __ReprocessLogs = connect<IMapState, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_ReprocessLogs);
export const ReprocessLogs = withRouter(__ReprocessLogs)